export { FEATURE_FLAGS } from './consts/flags.const';
export type { FeatureFlagKey } from './consts/flags.const';

export {
  FEATURES,
  FEATURE_NAMES,
  getFeatureDefinition,
} from './consts/features.const';
export type {
  BooleanFeatureName,
  FeatureDefinition,
  FeatureName,
  FeatureValue,
} from './consts/features.const';

export { FEATURE_MENU } from './consts/feature-menu.const';
export type { FeatureMenuEntry, MenuFeatureName } from './consts/feature-menu.const';

export { FeatureFlagProvider, useFeatureFlagContext } from './providers/FeatureFlagProvider';
export type { FeatureFlagContextValue, FlagState } from './providers/FeatureFlagProvider';

export { useFeatureFlag, useEnabledFeatures, useFeatureGuard } from './hooks';
export type {
  UseEnabledFeaturesResult,
  UseFeatureFlagResult,
} from './hooks/use-feature-flag.hook';
export type {
  FeatureGuardDeniedAction,
  UseFeatureGuardOptions,
  UseFeatureGuardResult,
} from './hooks/use-feature-guard.hook';

export { FeatureGuard } from './components/FeatureGuard';

export type {
  EvaluationContext,
  FeatureFlagAdapter,
  FlagEvaluation,
} from './client/adapter.types';
export { createDefaultAdapter, FliptAdapter, StaticFeatureFlagAdapter } from './client';
